import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import {
  MaterialIcon,
  MaterialIconRef,
} from 'src/components/framework/icons/material-icon'
import { Column, Grid } from 'src/components/framework/ui'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { useStockReportContext } from 'src/contexts/stock-report.context'
import { Colors } from 'src/shared/colors'

import * as styles from './faq.module.scss'
import { generateFaqList } from './faqList'

export const FAQ: React.FC = () => {
  const { report } = useStockReportContext()

  const faqList = generateFaqList(report)

  return (
    <>
      <SectionHeader>FAQ</SectionHeader>
      <Accordion className={styles.faqAccordion} allowZeroExpanded>
        {faqList.map((item, index) => (
          <AccordionItem className={styles.faqAccordion__item} key={index}>
            <AccordionItemHeading>
              <AccordionItemButton className={styles.faqAccordion__question}>
                <Grid alignHorizontally={'center'}>
                  <Column shrink="shrink">
                    <span className={styles.faqAccordion__icon}>
                      <MaterialIcon
                        icon={MaterialIconRef.ArrowRight}
                        size={18}
                        color={Colors.Text1}
                      />
                    </span>
                  </Column>
                  <Column>{item.question}</Column>
                </Grid>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={styles.faqAccordion__answer}>
              {item.answer}
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  )
}
